module.exports = __webpack_public_path__ + "static/media/cubic.5cd21efb.ttf";